var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKidnapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.125 1.926c-34.352 0-62.199 27.847-62.199 62.199s27.847 62.199 62.199 62.199 62.199-27.847 62.199-62.199-27.848-62.199-62.199-62.199zm-0.334 118.55c-13.121 0-25.198-4.473-34.789-11.976 7.071-6.864 33.416-32.45 36.378-35.509 5.1-5.267 11.704 2.842 11.704 2.842s11.202 16.219 12.54 17.222 3.01 1.588 4.765 0.167c1.756-1.421 0.334-3.678 0.334-3.678s-8.668-10.251-10.701-14.463c-2.341-4.849 2.926-5.434 2.926-5.434s23.575 2.592 24.662 2.508 2.341-0.585 2.424-2.842c0.084-2.257-2.006-2.592-2.006-2.592s-22.526-4.709-24.411-5.434c-2.174-0.836-3.432-2.525-3.762-3.846-0.502-2.006 2.09-2.508 2.09-2.508s21.318-5.016 23.325-5.936c2.006-0.92 2.09-2.842 1.338-4.514s-4.347-1.421-4.347-1.421-16.887 3.26-19.73 3.762c-2.842 0.502-5.106 0.691-7.524-0.836-3.177-2.006-0.418-4.682-0.418-4.682s16.886-14.212 18.475-16.469c1.588-2.257 1.087-3.511-0.585-4.849s-4.431 0.752-4.431 0.752-9.865 6.688-14.296 10.283-18.727 14.63-22.907 15.048-16.971-5.768-18.643-6.604-3.26-0.167-3.929 1.756 0.92 4.932 3.01 6.354c2.09 1.421 10.534 4.598 14.547 6.437s0.669 6.354 0.669 6.354l-38.919 25.256c-2.771-6.672-4.304-13.987-4.304-21.662 0-31.212 25.302-56.514 56.514-56.514s56.514 25.302 56.514 56.514-25.302 56.514-56.513 56.514z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidnapping);
export default __webpack_public_path__ + "static/media/kidnapping.cf0d5b360d71e6f9f93ced6537926dc1.svg";
export { ForwardRef as ReactComponent };